"use client";

import { subscribeToPendingInvitationsByEmail } from "@/lib/recipe-box-invitations-service";
import type { RecipeBoxInvitation } from "@/lib/types";
import type { FirestoreError } from "firebase/firestore";
import { useEffect, useState } from "react";

type PendingInvitationsState = {
  invitations: RecipeBoxInvitation[];
  loading: boolean;
  error: string | null;
};

export function usePendingRecipeBoxInvitations(
  email: string | null | undefined,
): PendingInvitationsState {
  const [state, setState] = useState<PendingInvitationsState>({
    invitations: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!email) {
      setState({ invitations: [], loading: false, error: null });
      return;
    }

    setState((prev) => ({ ...prev, loading: true, error: null }));

    const onError = (error: FirestoreError) => {
      console.error("Failed to load pending invitations", error);
      setState({ invitations: [], loading: false, error: "Unable to load pending invitations." });
    };

    const unsubEmail = subscribeToPendingInvitationsByEmail(
      email,
      (invitations) => {
        setState({ invitations, loading: false, error: null });
      },
      onError,
    );

    return () => {
      unsubEmail();
    };
  }, [email]);

  if (!email) {
    return { invitations: [], loading: false, error: null };
  }

  return state;
}
